var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal",class:{ 'is-active': _vm.open }},[_c('div',{staticClass:"modal-background",on:{"click":function($event){_vm.open = false}}}),_c('div',{staticClass:"modal-content"},[_c('p',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.src}})])]),_c('button',{staticClass:"modal-close is-large",attrs:{"aria-label":"close"},on:{"click":function($event){_vm.open = false}}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77f0026d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ImageModal.vue
// module id = null
// module chunks = 